"use strict";
var Command = (function () {
    function Command() {
        var _this = this;
        this.done = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    return Command;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Command;
//# sourceMappingURL=Command.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/controls/CommandControl/commands/Command.js
 ** module id = 928
 ** module chunks = 0
 **/